import { apiFetch } from './api';

export interface ExtraCredits {
    id: string;
    active: boolean;
    organizationId: string;
    organizationName: string;
    amount: number;
    used: number;
    reason: string;
    addedAt: string;
    addedBy: string;
    addedByName: string;
    isActive: boolean;
    expiresAt?: string;
}

export interface OrganizationExtraCredits {
    totalExtraCredits: number;
    activeExtraCredits: number;
    extraCreditsHistory: ExtraCredits[];
}

export interface AddExtraCreditsRequest {
    organizationId: string;
    amount: number;
    reason: string;
    expiresAt?: string;
}

export const extraCreditsApi = {
    async addExtraCredits(data: AddExtraCreditsRequest): Promise<{ message: string; extraCreditsId: string }> {
        try {
            return await apiFetch<{ message: string; extraCreditsId: string }>('/ExtraCredits/AddExtraCredits', {
                method: 'POST',
                body: JSON.stringify(data),
                auth: true,
            });
        } catch (error) {
            console.error('Error adding extra credits:', error);
            throw error;
        }
    },

    async getAllExtraCredits(): Promise<ExtraCredits[]> {
        try {
            return await apiFetch<ExtraCredits[]>('/ExtraCredits/GetAllExtraCredits', { auth: true });
        } catch (error) {
            console.error('Error fetching all extra credits:', error);
            throw error;
        }
    },

    async getOrganizationExtraCredits(): Promise<OrganizationExtraCredits> {
        try {
            return await apiFetch<OrganizationExtraCredits>('/ExtraCredits/GetOrganizationExtraCredits', { auth: true });
        } catch (error) {
            console.error('Error fetching organization extra credits:', error);
            throw error;
        }
    },

    async deactivateExtraCredits(extraCreditsId: string): Promise<{ message: string }> {
        try {
            return await apiFetch<{ message: string }>('/ExtraCredits/DeactivateExtraCredits', {
                method: 'POST',
                body: JSON.stringify(extraCreditsId),
                auth: true,
            });
        } catch (error) {
            console.error('Error deactivating extra credits:', error);
            throw error;
        }
    }
};
